/**
 * The words behind Settings → About & credits (legalSheet.ts). M39: the game carries no policy or terms prose; the
 * privacy policy is the static page `privacy.html` (also docs/PRIVACY.md), one link away, and a test keeps its date in
 * step with LEGAL_UPDATED. FINISH_PLAN WP4.5 (X15).
 */

/** Changes whenever the privacy policy changes (privacy.html and docs/PRIVACY.md carry the same date). */
export const LEGAL_UPDATED = "2026-10-24";

/**
 * Where the About sheet's "Privacy policy" row points: the bundled static page until Kevin sets the public URL for
 * the App Store release (docs/BUILD.md, iOS checklist; App Store Connect asks for the same URL).
 */
export const PRIVACY_URL = "privacy.html";

/**
 * Where players write to. Null until Kevin sets a real address for the App Store release (docs/BUILD.md, iOS
 * checklist); App Store Connect also asks for a support URL. While null the About sheet shows no support row.
 */
export const SUPPORT_CONTACT: string | null = null;

export interface Credit { readonly what: string; readonly who: string; readonly licence: string; readonly url?: string }

/**
 * Who made what: the game's own art first (its models, terrain, icons and interface are original, built in-house
 * from the Blender scripts under art/), then everything shipped that someone else made, with the licence it ships
 * under (CC-BY and the font licence require the attribution).
 */
export const CREDITS: readonly Credit[] = [
  { what: "Models, terrain, icons and art", who: "Made in-house for Highmarch", licence: "All rights reserved" },
  { what: "Music and sound design", who: "Composed and mixed in-house for Highmarch", licence: "All rights reserved" },
  { what: "Orchestral samples", who: "Sonatina Symphonic Orchestra, Mattias Westlund", licence: "CC Sampling Plus 1.0; SF2 conversion CC-BY 3.0", url: "https://creativecommons.org/licenses/by/3.0/" },
  { what: "Sound effects", who: "Sonniss GDC Game Audio Bundles", licence: "Royalty-free", url: "https://sonniss.com/gameaudiogdc" },
  { what: "Font: Fredoka", who: "Milena Brandão (Hafontia)", licence: "SIL Open Font License 1.1", url: "https://openfontlicense.org" },
  { what: "3D engine", who: "three.js authors", licence: "MIT", url: "https://github.com/mrdoob/three.js/blob/dev/LICENSE" },
  { what: "Mesh compression", who: "meshoptimizer, Arseny Kapoulkine", licence: "MIT", url: "https://github.com/zeux/meshoptimizer/blob/master/LICENSE.md" },
  { what: "Texture transcoder", who: "Basis Universal, Binomial LLC", licence: "Apache 2.0", url: "https://github.com/BinomialLLC/basis_universal/blob/master/LICENSE" },
  { what: "iOS app shell", who: "Capacitor, Ionic", licence: "MIT", url: "https://github.com/ionic-team/capacitor/blob/main/LICENSE" },
];
